<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">{{type === 'video' ? 'Playlists videos archive' : (type === 'image' ? 'Playlists images archive' : 'Playlists PDFs archive')}}</p>
    </header>

    <section class="modal-card-body" >
        <div v-if="noResources">The archive is empty.</div>
        <main class="grid" v-if="type === 'image'">
          <div v-for="(im,id) in libImages" :key="id">
            <img :src="im.url" @click="selectImage(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">
            <span class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''">{{im.name}}</span>
          </div>
          </main>

          <main class="grid" v-else-if="type === 'pdf'">
        <div v-for="(pd,id) in libPdfs" :key="id">
            <!--<img :src="im.url" @click="selectPdf(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">-->
            <div style="position:relative;">
            <iframe
    :src="pd.url"
    frameBorder="0"
    height="100%"
    width="100%"
></iframe>
            </div>
            <span class="caption" @click="selectImage(pd.url, pd.name, pd.file)" :style="pd.url === selectedUrl ? 'font-weight: bold' : ''" style="cursor:pointer">{{pd.name}}</span>
        </div>
        </main>

        <main class="gridV" v-else>
          <div v-for="(im,id) in libVideos" :key="id">
<my-video class="__cov-video"
    :sources="[{
          src: im.url,
          type: 'video/mp4'
        }]" :options="video.options"></my-video>
            <span @click="selectImage(im.url, im.name, im.file)" :class="{ active: hover }" class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''" style="cursor:pointer">
                {{im.name}}
            </span>
          </div>

        </main>
     </section>
     <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
         <p v-if="type === 'image'"><b>Selected image: </b>{{selectedName}}</p>
         <p v-else-if="type === 'pdf'"><b>Selected PDF: </b>{{selectedName}}</p>
         <p v-else><b>Selected video: </b>{{selectedName}}</p>
  </footer>

    <footer class="modal-card-foot">
        <div v-if="!noResources">
      <b-button type="is-info" @click="uploadPicture()">Select</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      </div>
      <div v-else>
        <b-button type="is-light" @click="closeModal()">Close</b-button>
      </div>
    </footer>

  </div>
</template>

<script>
import myVideo from 'vue-video'

export default {
  name: 'PlaylistsBin',
  props: ['propParent', 'type'],
  components: {
    myVideo
  },
  data: () => {
    return {
      libImages: [],
      libVideos: [],
      libPdfs: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      noResources: false,
      video: {
        // sources: ,
        options: {
          autoplay: false,
          volume: 0.6
          // poster: '/static/images/blackk.jpg'
        }
      },
      hover: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    var playlistDirsRef = null
    if (this.$store.state.playlistsArchive === null) {
      this.loadingComponent.close()
      this.noResources = true
    } else {
      var plArch = this.$store.state.playlistsArchive.items
      if (this.type === 'video') {
        this.globalLogger('playlists archv', plArch)
        var hasVideos = false
        var videoNameArray = null
        var exten = null
        for (let i = 0; i < plArch.length; i++) {
          videoNameArray = plArch[i].resName.split('.')
          exten = videoNameArray[videoNameArray.length - 1]
          this.globalLogger('exten', exten)
          if (exten !== 'jpg' && exten !== 'png' && exten !== 'jpeg' && exten !== 'jfif' && exten !== 'pjpeg' && exten !== 'pjp' && exten !== 'pdf') {
            hasVideos = true
            break
          }
        }
        if (hasVideos === false) {
          this.loadingComponent.close()
          this.noResources = true
        } else {
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/')
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/')
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  var file = new File([blob], fileRef.name, {type: blob.type})
                  if (blob.type.split('/')[0] === 'video') {
                    this.libVideos.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      } else if (this.type === 'image') {
        this.globalLogger('images')
        this.globalLogger('playlists archv', plArch)
        var hasImages = false
        var nameArray = null
        var exten1 = null
        for (let i = 0; i < plArch.length; i++) {
          nameArray = plArch[i].resName.split('.')
          exten1 = nameArray[nameArray.length - 1]
          this.globalLogger('plArch[i]', exten1)
          if (exten1 === 'jpg' || exten1 === 'png' || exten1 === 'jpeg' || exten1 === 'jfif' || exten1 === 'pjpeg' || exten1 === 'pjp') {
            hasImages = true
            break
          }
        }
        if (hasImages === false) {
          this.loadingComponent.close()
          this.noResources = true
        } else {
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/')
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/')
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  var file = new File([blob], fileRef.name, {type: blob.type})
                  if (blob.type.split('/')[0] === 'image') {
                    this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      } else {
        this.globalLogger('pdfssss')
        var hasPdfs = false
        var pdfNameArray = null
        var exten2 = null
        for (let i = 0; i < plArch.length; i++) {
          pdfNameArray = plArch[i].resName.split('.')
          exten2 = pdfNameArray[pdfNameArray.length - 1]
          this.globalLogger('plArch[i]', exten2)
          if (exten2 === 'pdf') {
            hasPdfs = true
            break
          }
        }
        if (hasPdfs === false) {
          this.loadingComponent.close()
          this.noResources = true
        } else {
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/')
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/')
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  var file = new File([blob], fileRef.name, {type: blob.type})
                  if (blob.type === 'application/pdf') {
                    this.libPdfs.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
                    this.globalLogger(this.libPdfs, 'libpdfs')
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectImage (url, name, file) {
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadPicture () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-gap:20px;
  align-items: center;
}
.gridV {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap:20px;
  align-items: center;
}
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/PlaylistsBin.vue